<div *ngIf="normativa && form" [formGroup]="form">
    <div class="font-semibold text-2xl mb-3">Misure</div>

    <div>
        <!-- Caso scambio semplice -->
        <ng-container *ngIf="deviatoio?.deviatoioTipologia?.id === 1">
            <app-misure-semplici-doppi [form]="form" [deviatoioId]="deviatoio" [normativa]="getNormativaByTab('1')" [formReady]="formReady" [isSemplice]="true" prefix=""></app-misure-semplici-doppi>
        </ng-container>

        <!-- Caso scambio doppio -->
        <ng-container *ngIf="deviatoio?.deviatoioTipologia?.id === 2">
            <p-tabs [(value)]="selectedTab" (valueChange)="onTabChange($event)">
                <p-tablist>
                    <p-tab value="ramo1"><span>1° ramo deviato</span></p-tab>
                    <p-tab value="ramo2"><span>2° ramo deviato</span></p-tab>
                    <p-tab value="cuore"><span>Cuore interno</span></p-tab>
                </p-tablist>

                <p-tabpanels>
                    <p-tabpanel value="ramo1">
                        <app-misure-semplici-doppi [form]="form" [deviatoioId]="deviatoio" [normativa]="getNormativaByTab('1')" [formReady]="formReady" prefix="ramo1_"></app-misure-semplici-doppi>
                    </p-tabpanel>
                    <p-tabpanel value="ramo2">
                        <app-misure-semplici-doppi [form]="form" [deviatoioId]="deviatoio" [normativa]="getNormativaByTab('2')" [formReady]="formReady" prefix="ramo2_"></app-misure-semplici-doppi>
                    </p-tabpanel>
                    <p-tabpanel value="cuore">
                        <app-misure-cuore [form]="form" [deviatoioId]="deviatoio" [normativa]="getNormativaByTab('3')" [formReady]="formReady" prefix="cuore_"></app-misure-cuore>
                    </p-tabpanel>
                </p-tabpanels>
            </p-tabs>
        </ng-container>

        <!-- Caso intersezione doppio -->
        <ng-container *ngIf="deviatoio?.deviatoioTipologia?.id === 3">
            <app-misure-intersezione [form]="form" [normativa]="normativa" [formReady]="formReady" [deviatoioId]="deviatoio" [(selectedTab)]="selectedTabIntersezione" [mode]="mode"> </app-misure-intersezione>
        </ng-container>
    </div>
</div>
